
export default function MapComponent() {
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.2177991007034!2d10.163369111451972!3d36.83725956549372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd3360df45447d%3A0x7b97b942035ad340!2sANIMALIA%20PLUS!5e0!3m2!1sfr!2stn!4v1754997556147!5m2!1sfr!2stn";

  return (
    <div style={{ width: '100%', height: '450px', borderRadius: '8px', overflow: 'hidden' }}>
      <iframe
        title="Google Map"
        src={mapSrc}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
